export var Role;
(function (Role) {
    Role["ROLE_SUPER_ADMIN"] = "ROLE_SUPER_ADMIN";
    Role["ROLE_ADMIN"] = "ROLE_ADMIN";
    Role["ROLE_ADMIN_USER_VIEW"] = "ROLE_ADMIN_USER_VIEW";
    Role["ROLE_ADMIN_CHANNEL_VIEW"] = "ROLE_ADMIN_CHANNEL_VIEW";
    Role["ROLE_ADMIN_WALLET_TRANSACTION_VIEW"] = "ROLE_ADMIN_WALLET_TRANSACTION_VIEW";
    Role["ROLE_ADMIN_INCOME_VIEW"] = "ROLE_ADMIN_INCOME_VIEW";
    Role["ROLE_ADMIN_VIDEO_VIEW"] = "ROLE_ADMIN_VIDEO_VIEW";
    Role["ROLE_ADMIN_USER_EDIT"] = "ROLE_ADMIN_USER_EDIT";
    Role["ROLE_ADMIN_CHANNEL_EDIT"] = "ROLE_ADMIN_CHANNEL_EDIT";
    Role["ROLE_ADMIN_WALLET_TRANSACTION_EDIT"] = "ROLE_ADMIN_WALLET_TRANSACTION_EDIT";
    Role["ROLE_ADMIN_INCOME_EDIT"] = "ROLE_ADMIN_INCOME_EDIT";
    Role["ROLE_ADMIN_VIDEO_EDIT"] = "ROLE_ADMIN_VIDEO_EDIT";
    Role["ROLE_ADMIN_USER_DELETE"] = "ROLE_ADMIN_USER_DELETE";
    Role["ROLE_ADMIN_CHANNEL_DELETE"] = "ROLE_ADMIN_CHANNEL_DELETE";
    Role["ROLE_ADMIN_WALLET_TRANSACTION_DELETE"] = "ROLE_ADMIN_WALLET_TRANSACTION_DELETE";
    Role["ROLE_ADMIN_INCOME_DELETE"] = "ROLE_ADMIN_INCOME_DELETE";
    Role["ROLE_ADMIN_VIDEO_DELETE"] = "ROLE_ADMIN_VIDEO_DELETE";
    Role["ROLE_ADMIN_FINANCIAL"] = "ROLE_ADMIN_FINANCIAL";
    Role["ROLE_ADMIN_LOGIN"] = "ROLE_ADMIN_LOGIN";
    Role["ROLE_ADMIN_CHANNEL_CREATE"] = "ROLE_ADMIN_CHANNEL_CREATE";
    Role["ROLE_ADMIN_WALLET_TRANSACTION_CREATE"] = "ROLE_ADMIN_WALLET_TRANSACTION_CREATE";
    Role["ROLE_ADMIN_INCOME_CREATE"] = "ROLE_ADMIN_INCOME_CREATE";
    Role["ROLE_ADMIN_VIDEO_CREATE"] = "ROLE_ADMIN_VIDEO_CREATE";
})(Role || (Role = {}));
export const RoleTree = {
    ROLE_SUPER_ADMIN: [
        Role.ROLE_ADMIN,
        Role.ROLE_ADMIN_FINANCIAL,
    ],
    ROLE_ADMIN: [
        Role.ROLE_ADMIN_LOGIN,
        Role.ROLE_ADMIN_USER_EDIT,
        Role.ROLE_ADMIN_WALLET_TRANSACTION_EDIT,
        Role.ROLE_ADMIN_INCOME_EDIT,
        Role.ROLE_ADMIN_VIDEO_EDIT,
        Role.ROLE_ADMIN_CHANNEL_EDIT,
        Role.ROLE_ADMIN_WALLET_TRANSACTION_CREATE,
        Role.ROLE_ADMIN_INCOME_CREATE,
        Role.ROLE_ADMIN_VIDEO_CREATE,
        Role.ROLE_ADMIN_CHANNEL_CREATE,
    ],
    [Role.ROLE_ADMIN_USER_EDIT]: [Role.ROLE_ADMIN_USER_VIEW],
    [Role.ROLE_ADMIN_INCOME_EDIT]: [Role.ROLE_ADMIN_INCOME_VIEW],
    [Role.ROLE_ADMIN_CHANNEL_EDIT]: [Role.ROLE_ADMIN_CHANNEL_VIEW],
    [Role.ROLE_ADMIN_VIDEO_EDIT]: [Role.ROLE_ADMIN_VIDEO_VIEW],
    [Role.ROLE_ADMIN_WALLET_TRANSACTION_EDIT]: [Role.ROLE_ADMIN_WALLET_TRANSACTION_VIEW],
    [Role.ROLE_ADMIN_USER_DELETE]: [Role.ROLE_ADMIN_USER_VIEW],
    [Role.ROLE_ADMIN_INCOME_DELETE]: [Role.ROLE_ADMIN_INCOME_VIEW],
    [Role.ROLE_ADMIN_CHANNEL_DELETE]: [Role.ROLE_ADMIN_CHANNEL_VIEW],
    [Role.ROLE_ADMIN_VIDEO_DELETE]: [Role.ROLE_ADMIN_VIDEO_VIEW],
    [Role.ROLE_ADMIN_WALLET_TRANSACTION_DELETE]: [Role.ROLE_ADMIN_WALLET_TRANSACTION_VIEW],
    [Role.ROLE_ADMIN_INCOME_CREATE]: [Role.ROLE_ADMIN_INCOME_VIEW],
    [Role.ROLE_ADMIN_CHANNEL_CREATE]: [Role.ROLE_ADMIN_CHANNEL_VIEW],
    [Role.ROLE_ADMIN_VIDEO_CREATE]: [Role.ROLE_ADMIN_VIDEO_VIEW],
    [Role.ROLE_ADMIN_WALLET_TRANSACTION_CREATE]: [Role.ROLE_ADMIN_WALLET_TRANSACTION_VIEW],
    [Role.ROLE_ADMIN_FINANCIAL]: [
        Role.ROLE_ADMIN_WALLET_TRANSACTION_EDIT,
        Role.ROLE_ADMIN_WALLET_TRANSACTION_CREATE,
        Role.ROLE_ADMIN_INCOME_EDIT,
        Role.ROLE_ADMIN_INCOME_CREATE,
    ],
};
export default Role;
//# sourceMappingURL=role.js.map